export interface StatusProps {
  viewed: boolean
  progress: number
}

export enum StatusType {
  CREATED = 1,
  QUEUING = 2,
  WAITING,
  DOWNLOADING,
  CONNECTING,
  PERFORMED,
  VIEWED,
  DELETING,
  DELETED,
  AUTH_ERROR,
  CONF_ERROR,
  NO_DATA,
  DOWNLOAD_ERROR,
  ERROR,
}
